import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";

export class CompetitorPlayerStatsModuleStatsDisplayEvent extends BaseAnalyticsEvent {
  gameId: Number;
  status: Number;
  athleteId: String;
  sportTypeId: String;
  source: String;
  isHeatmap: Boolean;
  isFirst: Boolean;

  constructor(params) {
    super('', 'display', 'live-stats');

    this.gameId = params.gameId;
    this.status = params.status;
    this.athleteId = params.athleteId;
    this.sportTypeId = params.sportTypeId;
    this.source = params.source;
    this.isHeatmap = params.isHeatmap;
    this.isFirst = params.isFirst;
  }

  get properties() {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.athleteId = this.athleteId;
    properties.sportTypeId = this.sportTypeId;
    properties.source = this.source;
    properties.isHeatmap = Number(this.isHeatmap);
    properties.isFirst = Number(this.isFirst);

    return properties;
  }
}